export const RK_ROLE = {
  PARENT: 'Member',
  EDUCATOR: 'Educator',
  CHIEF: 'Chief'
}
